import React, { Component } from 'react';

class Quotes extends Component {
  render(){
    return(
      <section>
        <div className="grid">
          <div className="container small">
              <div className="wrap">
                <div className="col col-1">
                    <q className="slogan">{this.props.question}</q>
                </div>

                <div className="col col-1">
                  <p className="lead">{this.props.answer}</p>
                </div>
              </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Quotes;



// WEBPACK FOOTER //
// ./src/layout/Quotes.js